import { INVEST_TRANSFER_DIGITAL_ELIGIBLE, INVEST_TRANSFER_PAPER_FORM, WEALTH_ACCOUNT_TYPE, } from '../constants';
export function isInvest(account) {
    return account.domainDetails.domain === 'INVEST';
}
export function isManagedPortfolio(account) {
    return isInvest(account) && account.domainDetails.isManagedPortfolio;
}
export function isWealthAccount(account) {
    var accountType = (account.accountType && account.accountType.toUpperCase()) || '';
    return isInvest(account) && accountType === WEALTH_ACCOUNT_TYPE;
}
export function isIraWithdrawalEligible(account) {
    return (isInvest(account) &&
        !account.domainDetails.isManagedPortfolio &&
        INVEST_TRANSFER_DIGITAL_ELIGIBLE.includes(account.domainDetails.natureCode || account.accountType));
}
export function hasPaperForm(account) {
    if (!isInvest(account))
        return false;
    var natureCode = account.domainDetails.natureCode || account.accountType;
    return INVEST_TRANSFER_PAPER_FORM.includes(natureCode);
}
//# sourceMappingURL=invest.js.map